import * as constants from '../Constatnts'
import { getTokenFromState, handleError } from '../CommonFunctions';
import axios from 'axios';



export function getCampaignDetails (key)  {
  return async (dispatch, getState) => {
    try {
      const token = getTokenFromState(getState);

      const response = await axios.get(
        `${constants.API_URL}/crm/campaigndetails?key=${key}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleError(error);
    }
  };
};

export function getCampaign (storeID)  {
  return async (dispatch, getState) => {
    try {
      const token = getTokenFromState(getState);

      const response = await axios.get(
        `${constants.API_URL}/crm/campaign?storeID=${storeID}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleError(error);
    }
  };
};

export function deleteCampaign (data)  {
  return async (dispatch, getState) => {
    try {
      const token = getTokenFromState(getState);

      const response = await axios.delete(
        `${constants.API_URL}/crm/campaign/${data}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error) {
      handleError(error);
    }
  };
};

export function updateCampaignStatus(id, status) {
  return async (dispatch, getState) => {
    try {
      const token = getTokenFromState(getState);

      const response = await axios.put(
        `${constants.API_URL}/crm/campaign/status/${id}/${status}`,
        {}, // request body
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      return response.data;
    } catch (error) {
      handleError(error);
    }
  };
}

export function getCustmerForCampaign (from = 0,
  size = 10,
  stores,
  customerVisited,
  customerInDays,
  membership,
  gender,
  walletBalanceFrom,
  walletBalanceTo,
  outStandingAmtFrom,
  outStandingAmtTo,
  searchAfter) {
  return async (dispatch, getState) => {
    try {
      const baseParams = { stores: stores };

      // Check if any filter parameters have values
      const hasFilters = [
        customerVisited,
        customerInDays,
        membership,
        gender,
        walletBalanceFrom,
        walletBalanceTo,
        outStandingAmtFrom,
        outStandingAmtTo,
      ].some(function(param) {
        return param !== undefined && param !== "";
      });

      // Create final params object
      const params = {};

      // Copy baseParams properties
      if (baseParams.hasOwnProperty('stores')) {
        params.stores = baseParams.stores;
      }

      // Only include from/size if no filters are present
      params.from = from;
      params.size = size;

      if (searchAfter !== undefined && searchAfter !== "" && searchAfter!==null) {
        params.searchAfter = JSON.stringify(searchAfter);
      }

      // Conditionally add filter parameters if they have values
      if (customerVisited !== undefined && customerVisited !== "") {
        params.customerVisited = customerVisited;
      }
      if (customerInDays !== undefined && customerInDays !== "") {
        params.customerInDays = customerInDays;
      }
      if (membership !== undefined && membership !== "") {
        params.membership = membership;
      }
      if (gender !== undefined && gender !== "") {
        params.gender = gender;
      }
      if (walletBalanceFrom !== undefined && walletBalanceFrom !== "") {
        params.walletBalanceFrom = walletBalanceFrom;
      }
      if (walletBalanceTo !== undefined && walletBalanceTo !== "") {
        params.walletBalanceTo = walletBalanceTo;
      }
      if (outStandingAmtFrom !== undefined && outStandingAmtFrom !== "") {
        params.outStandingAmtFrom = outStandingAmtFrom;
      }
      if (outStandingAmtTo !== undefined && outStandingAmtTo !== "") {
        params.outStandingAmtTo = outStandingAmtTo;
      }

      const token = getTokenFromState(getState);

      const response = await axios.get(
        constants.API_URL + "/crm/customerforcampaign",
        {
          params: params,
          headers: { Authorization: "Bearer " + token }
        }
      );

      return response.data;
    } catch (error) {
      handleError(error);
    }
  };
}

export function getNonVisitedCustmerForCampaign (
  from = 0,
  size = 10,
  stores,
  customerVisited,
  customerInDays,
  membership,
  gender,
  walletBalanceFrom,
  walletBalanceTo,
  outStandingAmtFrom,
  outStandingAmtTo,
  searchAfter ) {
  return async (dispatch, getState) => {
    try {
      const baseParams = { stores };

      // Check if any filter parameters have values
        const hasFilters = [
      customerVisited,
      customerInDays,
      membership,
      gender,
      walletBalanceFrom,
      walletBalanceTo,
      outStandingAmtFrom,
      outStandingAmtTo,
    ].some((param) => param !== undefined && param !== "");

    // Create final params object
    const params = { ...baseParams };

    // Only include from/size if no filters are present
    params.from = from;
    params.size = size;

    if (searchAfter) {
      params.searchAfter = JSON.stringify(searchAfter);
    }

    // Conditionally add filter parameters if they have values
    if (customerVisited !== undefined && customerVisited !== "") {
      params.customerVisited = customerVisited;
    }
    if (customerInDays !== undefined && customerInDays !== "") {
      params.customerInDays = customerInDays;
    }
    if (membership !== undefined && membership !== "") {
      params.membership = membership;
    }
    if (gender !== undefined && gender !== "") {
      params.gender = gender;
    }
    if (walletBalanceFrom !== undefined && walletBalanceFrom !== "") {
      params.walletBalanceFrom = walletBalanceFrom;
    }
    if (walletBalanceTo !== undefined && walletBalanceTo !== "") {
      params.walletBalanceTo = walletBalanceTo;
    }
    if (outStandingAmtFrom !== undefined && outStandingAmtFrom !== "") {
      params.outStandingAmtFrom = outStandingAmtFrom;
    }
    if (outStandingAmtTo !== undefined && outStandingAmtTo !== "") {
      params.outStandingAmtTo = outStandingAmtTo;
    }

      const token = getTokenFromState(getState);

      const response = await axios.get(
        constants.API_URL + "/crm/nonvisitedcustomerforcampaign",
        {
          params: params,
          headers: { Authorization: "Bearer " + token }
        }
      );

      return response.data;
    } catch (error) {
      handleError(error);
    }
  };
}

export function getSalesCustomersForCampaign(
  customers,
  purchaseAmtFrom = 0,
  purchaseAmtTo = 0
) {
  return async (dispatch, getState) => {
    try {
      const params = {
        customers: customers,
        purchaseAmtFrom: purchaseAmtFrom,
        purchaseAmtTo: purchaseAmtTo,
      };

      const token = getTokenFromState(getState);

      const response = await axios.post(
        constants.API_URL + "/crm/getsalescustomersforcampaign",
        params, 
        {
          headers: { Authorization: "Bearer " + token } // ✅ Headers in config
        }
      );

      return response.data;
    } catch (error) {
      handleError(error);
    }
  };
}

export function addCampaign(data) {
  return async (dispatch, getState) => {
    try {
    

      const token = getTokenFromState(getState);

      const response = await axios.post(
        constants.API_URL + "/crm/campaign",
        data, 
        {
          headers: { Authorization: "Bearer " + token } // ✅ Headers in config
        }
      );

      return response.data;
    } catch (error) {
      handleError(error);
    }
  };
}

export function updateCampaign(data) {
  return async (dispatch, getState) => {
    try {
    

      const token = getTokenFromState(getState);

      const response = await axios.post(
        constants.API_URL + `/crm/campaign/${data.key}`,
        data, 
        {
          headers: { Authorization: "Bearer " + token } // ✅ Headers in config
        }
      );

      return response.data;
    } catch (error) {
      handleError(error);
    }
  };
}



